export interface CastMember {
  name: string;
  role: string;
  avatar: string;
}

export interface Series {
  id: string;
  title: string;
  poster: string;
  heroImage: string;
  genres: string[];
  region: string;
  year: number;
  rating: number;
  totalEpisodes: number;
  updatedEpisodes: number;
  status: string;
  updateDate: string;
  synopsis: string;
  director: string;
  cast: CastMember[];
  tags: string[];
  featured: boolean;
  views: string;
}

export const actorAvatars: string[] = [
  'https://readdy.ai/api/search-image?query=Editorial%20portrait%20headshot%20of%20a%20professional%20East%20Asian%20male%20actor%20in%20his%20thirties%20wearing%20a%20dark%20tailored%20suit%2C%20neutral%20warm%20studio%20backdrop%2C%20soft%20cinematic%20side%20lighting%2C%20shallow%20depth%20of%20field%2C%20refined%20entertainment%20magazine%20photography%2C%20high%20detail&width=400&height=400&seq=actor-01&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Editorial%20portrait%20headshot%20of%20a%20graceful%20East%20Asian%20actress%20in%20her%20twenties%20with%20long%20black%20hair%20and%20a%20soft%20cream%20top%2C%20neutral%20studio%20backdrop%2C%20soft%20cinematic%20lighting%2C%20shallow%20depth%20of%20field%2C%20refined%20entertainment%20photography%2C%20high%20detail&width=400&height=400&seq=actor-02&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Editorial%20portrait%20headshot%20of%20a%20dignified%20East%20Asian%20male%20actor%20in%20his%20fifties%20with%20a%20grey%20beard%20and%20dark%20coat%2C%20neutral%20studio%20backdrop%2C%20soft%20cinematic%20lighting%2C%20shallow%20depth%20of%20field%2C%20refined%20entertainment%20photography%2C%20high%20detail&width=400&height=400&seq=actor-03&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Editorial%20portrait%20headshot%20of%20an%20elegant%20East%20Asian%20woman%20in%20her%20early%20thirties%20wearing%20a%20dark%20evening%20dress%2C%20neutral%20warm%20studio%20backdrop%2C%20soft%20cinematic%20lighting%2C%20shallow%20depth%20of%20field%2C%20refined%20entertainment%20photography%2C%20high%20detail&width=400&height=400&seq=actor-04&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Editorial%20portrait%20headshot%20of%20a%20cheerful%20East%20Asian%20young%20man%20in%20his%20twenties%20wearing%20a%20casual%20denim%20jacket%2C%20neutral%20studio%20backdrop%2C%20soft%20cinematic%20lighting%2C%20shallow%20depth%20of%20field%2C%20refined%20entertainment%20photography%2C%20high%20detail&width=400&height=400&seq=actor-05&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Editorial%20portrait%20headshot%20of%20a%20poised%20East%20Asian%20woman%20in%20her%20forties%20with%20a%20sharp%20bob%20haircut%20and%20a%20tailored%20blazer%2C%20neutral%20studio%20backdrop%2C%20soft%20cinematic%20lighting%2C%20refined%20entertainment%20photography%2C%20high%20detail&width=400&height=400&seq=actor-06&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Editorial%20portrait%20headshot%20of%20an%20East%20Asian%20male%20actor%20in%20his%20forties%20wearing%20glasses%20and%20a%20knit%20sweater%2C%20neutral%20studio%20backdrop%2C%20soft%20cinematic%20lighting%2C%20shallow%20depth%20of%20field%2C%20refined%20entertainment%20photography%2C%20high%20detail&width=400&height=400&seq=actor-07&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Editorial%20portrait%20headshot%20of%20a%20bright%20East%20Asian%20young%20woman%20in%20her%20late%20teens%20with%20a%20casual%20colorful%20style%2C%20neutral%20studio%20backdrop%2C%20soft%20cinematic%20lighting%2C%20refined%20entertainment%20photography%2C%20high%20detail&width=400&height=400&seq=actor-08&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Editorial%20portrait%20headshot%20of%20a%20rugged%20East%20Asian%20male%20actor%20in%20his%20thirties%20wearing%20a%20dark%20leather%20jacket%2C%20neutral%20studio%20backdrop%2C%20soft%20cinematic%20lighting%2C%20shallow%20depth%20of%20field%2C%20refined%20entertainment%20photography%2C%20high%20detail&width=400&height=400&seq=actor-09&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Editorial%20portrait%20headshot%20of%20an%20elegant%20East%20Asian%20woman%20in%20her%20thirties%20wearing%20a%20silk%20blouse%2C%20neutral%20warm%20studio%20backdrop%2C%20soft%20cinematic%20lighting%2C%20shallow%20depth%20of%20field%2C%20refined%20entertainment%20photography%2C%20high%20detail&width=400&height=400&seq=actor-10&orientation=squarish',
];

export const seriesList: Series[] = [
  {
    id: 'mom-friend',
    title: '妈妈的朋友',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20drama%20key%20art%20of%20an%20elegant%20woman%20standing%20by%20a%20sunlit%20window%20in%20soft%20warm%20light%2C%20minimal%20neutral%20gradient%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20muted%20sophisticated%20palette%2C%20professional%20entertainment%20poster%2C%20high%20detail&width=600&height=900&seq=poster-01&orientation=portrait',
    heroImage:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20panoramic%20key%20art%20of%20a%20serene%20seaside%20town%20at%20golden%20hour%20with%20soft%20mist%2C%20dramatic%20atmospheric%20lighting%2C%20minimal%20composition%20with%20copy%20space%2C%20elegant%20editorial%20entertainment%20banner%2C%20subtle%20film%20grain%2C%20professional%20color%20grading%2C%20high%20detail&width=1600&height=900&seq=hero-01&orientation=landscape',
    genres: ['爱情', '家庭', '剧情'],
    region: '韩国',
    year: 2024,
    rating: 8.7,
    totalEpisodes: 16,
    updatedEpisodes: 12,
    status: '更新至第12集',
    updateDate: '2026-10-08',
    synopsis:
      '一场意外让两个原本平行的家庭产生了交集。温柔内敛的徐妍与母亲多年的挚友林道贤重逢，在共同面对生活难题的过程中，一段跨越年龄与秘密的情感悄然生长，也牵连出上一代人未曾言说的往事。',
    director: '郑成勋',
    cast: [
      { name: '林书曼', role: '饰 徐妍', avatar: actorAvatars[1] },
      { name: '郑北方', role: '饰 林道贤', avatar: actorAvatars[0] },
      { name: '唐棠', role: '饰 徐母 金淑英', avatar: actorAvatars[5] },
    ],
    tags: ['情感', '治愈', '都市'],
    featured: true,
    views: '2.3亿',
  },
  {
    id: 'long-night',
    title: '长夜将明',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20drama%20key%20art%20of%20a%20lone%20detective%20standing%20under%20dim%20rain%20soaked%20street%20lamps%2C%20minimal%20dark%20neutral%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20muted%20sophisticated%20palette%2C%20professional%20entertainment%20poster%2C%20high%20detail&width=600&height=900&seq=poster-02&orientation=portrait',
    heroImage:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20panoramic%20key%20art%20of%20a%20rain%20soaked%20city%20street%20at%20night%20with%20glowing%20lights%20and%20mist%2C%20dramatic%20atmospheric%20lighting%2C%20minimal%20composition%20with%20copy%20space%2C%20elegant%20editorial%20banner%2C%20moody%20color%20grading%2C%20high%20detail&width=1600&height=900&seq=hero-02&orientation=landscape',
    genres: ['悬疑', '剧情', '犯罪'],
    region: '中国大陆',
    year: 2025,
    rating: 9.1,
    totalEpisodes: 24,
    updatedEpisodes: 18,
    status: '更新至第18集',
    updateDate: '2026-10-09',
    synopsis:
      '一桩尘封十五年的旧案重新浮出水面，刑警队长陆时予被指派重启调查。随着线索层层剥开，他发现真相与自己的身世紧紧纠缠，长夜之中，唯有坚持才能等到黎明。',
    director: '沈砚',
    cast: [
      { name: '陆时予', role: '饰 刑警 陆时予', avatar: actorAvatars[0] },
      { name: '顾清欢', role: '饰 法医 顾清欢', avatar: actorAvatars[3] },
      { name: '秦淮', role: '饰 队长 秦卫东', avatar: actorAvatars[2] },
    ],
    tags: ['刑侦', '悬疑', '高能'],
    featured: true,
    views: '3.1亿',
  },
  {
    id: 'shan-hai',
    title: '山海不辞',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20costume%20drama%20key%20art%20of%20a%20graceful%20figure%20in%20flowing%20hanfu%20on%20misty%20mountains%2C%20minimal%20neutral%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20muted%20sophisticated%20palette%2C%20professional%20entertainment%20poster%2C%20high%20detail&width=600&height=900&seq=poster-03&orientation=portrait',
    heroImage:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20panoramic%20key%20art%20of%20ancient%20misty%20mountains%20and%20a%20lone%20pavilion%20at%20dawn%2C%20dramatic%20atmospheric%20lighting%2C%20minimal%20composition%20with%20copy%20space%2C%20elegant%20oriental%20editorial%20banner%2C%20subtle%20film%20grain%2C%20high%20detail&width=1600&height=900&seq=hero-03&orientation=landscape',
    genres: ['古装', '爱情', '剧情'],
    region: '中国大陆',
    year: 2024,
    rating: 8.4,
    totalEpisodes: 40,
    updatedEpisodes: 40,
    status: '全40集',
    updateDate: '2026-09-26',
    synopsis:
      '山与海相隔千年，却因一场战乱让两颗心走到一起。将门之女温言与隐世谋士宋清辞并肩守护家国，在权谋与烽火之间，写下一段不辞山海的深情。',
    director: '叶知秋',
    cast: [
      { name: '温言', role: '饰 温言', avatar: actorAvatars[1] },
      { name: '宋清辞', role: '饰 宋清辞', avatar: actorAvatars[4] },
      { name: '许南烟', role: '饰 长公主', avatar: actorAvatars[6] },
    ],
    tags: ['古装', '权谋', '虐恋'],
    featured: false,
    views: '1.8亿',
  },
  {
    id: 'city-float',
    title: '都市浮生录',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20drama%20key%20art%20of%20a%20young%20professional%20walking%20through%20neon%20city%20streets%20at%20night%2C%20minimal%20neutral%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20muted%20sophisticated%20palette%2C%20professional%20poster%2C%20high%20detail&width=600&height=900&seq=poster-04&orientation=portrait',
    heroImage:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20panoramic%20key%20art%20of%20a%20modern%20city%20skyline%20at%20blue%20hour%20with%20warm%20window%20lights%2C%20dramatic%20atmospheric%20lighting%2C%20minimal%20composition%20with%20copy%20space%2C%20elegant%20editorial%20banner%2C%20high%20detail&width=1600&height=900&seq=hero-04&orientation=landscape',
    genres: ['都市', '剧情', '职场'],
    region: '中国大陆',
    year: 2025,
    rating: 8.0,
    totalEpisodes: 30,
    updatedEpisodes: 22,
    status: '更新至第22集',
    updateDate: '2026-10-07',
    synopsis:
      '三个从县城来到大城市的年轻人，在同一间出租屋相遇。他们怀揣梦想，在浮华与现实之间反复碰撞，用各自的方式寻找属于自己的位置。',
    director: '周叙',
    cast: [
      { name: '何思远', role: '饰 陈屿', avatar: actorAvatars[4] },
      { name: '苏晚晴', role: '饰 林一诺', avatar: actorAvatars[7] },
      { name: '郑北方', role: '饰 老周', avatar: actorAvatars[2] },
    ],
    tags: ['现实主义', '群像', '成长'],
    featured: false,
    views: '1.2亿',
  },
  {
    id: 'years-light',
    title: '岁月拾光',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20family%20drama%20key%20art%20of%20a%20warm%20family%20gathered%20in%20a%20cozy%20old%20living%20room%2C%20minimal%20neutral%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20muted%20sophisticated%20palette%2C%20professional%20poster%2C%20high%20detail&width=600&height=900&seq=poster-05&orientation=portrait',
    heroImage:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20panoramic%20key%20art%20of%20a%20quiet%20old%20town%20alley%20at%20warm%20sunset%20with%20soft%20light%2C%20dramatic%20atmospheric%20lighting%2C%20minimal%20composition%20with%20copy%20space%2C%20elegant%20editorial%20banner%2C%20high%20detail&width=1600&height=900&seq=hero-05&orientation=landscape',
    genres: ['家庭', '治愈', '剧情'],
    region: '中国大陆',
    year: 2023,
    rating: 8.8,
    totalEpisodes: 36,
    updatedEpisodes: 36,
    status: '全36集',
    updateDate: '2026-09-18',
    synopsis:
      '一间开了三十年的老照相馆，见证了小镇上几代人的悲欢离合。退休摄影师用镜头拾起被岁月遗忘的光影，也慢慢拼回了自己与家人之间的和解。',
    director: '叶知秋',
    cast: [
      { name: '秦淮', role: '饰 老摄影师 周德海', avatar: actorAvatars[2] },
      { name: '唐棠', role: '饰 女儿 周念', avatar: actorAvatars[5] },
      { name: '何思远', role: '饰 学徒 小何', avatar: actorAvatars[4] },
    ],
    tags: ['温情', '年代', '治愈'],
    featured: false,
    views: '1.5亿',
  },
  {
    id: 'dark-surge',
    title: '暗涌',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20crime%20drama%20key%20art%20of%20a%20tense%20silhouette%20in%20a%20dim%20harbor%20warehouse%2C%20minimal%20dark%20neutral%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20muted%20sophisticated%20palette%2C%20professional%20poster%2C%20high%20detail&width=600&height=900&seq=poster-06&orientation=portrait',
    heroImage:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20panoramic%20key%20art%20of%20a%20dim%20harbor%20at%20night%20with%20cold%20blue%20shadows%20and%20fog%2C%20dramatic%20atmospheric%20lighting%2C%20minimal%20composition%20with%20copy%20space%2C%20elegant%20editorial%20banner%2C%20moody%20grading%2C%20high%20detail&width=1600&height=900&seq=hero-06&orientation=landscape',
    genres: ['悬疑', '犯罪', '剧情'],
    region: '中国香港',
    year: 2025,
    rating: 8.9,
    totalEpisodes: 20,
    updatedEpisodes: 14,
    status: '更新至第14集',
    updateDate: '2026-10-09',
    synopsis:
      '平静的港口之下暗流涌动。一名卧底警探在长达五年的潜伏中逐渐模糊了身份，当收网的时刻来临，他必须在忠诚与生存之间做出抉择。',
    director: '沈砚',
    cast: [
      { name: '顾清欢', role: '饰 卧底 程曦', avatar: actorAvatars[3] },
      { name: '陆时予', role: '饰 督察 方卓', avatar: actorAvatars[8] },
      { name: '唐棠', role: '饰 情报员 阿Man', avatar: actorAvatars[5] },
    ],
    tags: ['卧底', '港剧', '高能'],
    featured: true,
    views: '2.6亿',
  },
  {
    id: 'spring-late',
    title: '春日迟迟',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20youth%20drama%20key%20art%20of%20a%20cheerful%20student%20on%20a%20campus%20in%20spring%20bloom%2C%20minimal%20neutral%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20muted%20sophisticated%20palette%2C%20professional%20poster%2C%20high%20detail&width=600&height=900&seq=poster-07&orientation=portrait',
    heroImage:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20panoramic%20key%20art%20of%20a%20sunny%20campus%20walkway%20lined%20with%20spring%20blossoms%2C%20dramatic%20atmospheric%20lighting%2C%20minimal%20composition%20with%20copy%20space%2C%20elegant%20editorial%20banner%2C%20high%20detail&width=1600&height=900&seq=hero-07&orientation=landscape',
    genres: ['青春', '爱情', '校园'],
    region: '中国台湾',
    year: 2024,
    rating: 7.9,
    totalEpisodes: 16,
    updatedEpisodes: 16,
    status: '全16集',
    updateDate: '2026-09-12',
    synopsis:
      '转学生林晚晴在春日迟迟的季节里遇见了沉默的少年。一段关于暗恋、错过与重新出发的校园故事，在毕业前的最后一个春天缓缓展开。',
    director: '周叙',
    cast: [
      { name: '苏晚晴', role: '饰 林晚晴', avatar: actorAvatars[7] },
      { name: '何思远', role: '饰 江野', avatar: actorAvatars[4] },
      { name: '林书曼', role: '饰 闺蜜 阿茶', avatar: actorAvatars[1] },
    ],
    tags: ['校园', '初恋', '治愈'],
    featured: false,
    views: '8600万',
  },
  {
    id: 'return-train',
    title: '归途列车',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20drama%20key%20art%20of%20a%20solitary%20traveler%20gazing%20out%20of%20a%20moving%20train%20window%2C%20minimal%20neutral%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20muted%20palette%2C%20professional%20poster%2C%20high%20detail&width=600&height=900&seq=poster-08&orientation=portrait',
    heroImage:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20panoramic%20key%20art%20of%20a%20train%20crossing%20vast%20open%20plains%20at%20dusk%2C%20dramatic%20atmospheric%20lighting%2C%20minimal%20composition%20with%20copy%20space%2C%20elegant%20editorial%20banner%2C%20high%20detail&width=1600&height=900&seq=hero-08&orientation=landscape',
    genres: ['剧情', '公路', '亲情'],
    region: '中国大陆',
    year: 2024,
    rating: 8.2,
    totalEpisodes: 28,
    updatedEpisodes: 28,
    status: '全28集',
    updateDate: '2026-09-20',
    synopsis:
      '一趟跨越三千公里的列车，载着形形色色的归乡人。失业青年、返乡母亲与退休教师在同一节车厢相遇，各自的旅程最终拼出一幅关于家的时代画卷。',
    director: '叶知秋',
    cast: [
      { name: '陆时予', role: '饰 陈舟', avatar: actorAvatars[8] },
      { name: '许南烟', role: '饰 阿敏', avatar: actorAvatars[6] },
      { name: '秦淮', role: '饰 退休教师', avatar: actorAvatars[2] },
    ],
    tags: ['公路', '群像', '现实主义'],
    featured: false,
    views: '1.1亿',
  },
  {
    id: 'star-sea',
    title: '星辰大海',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20sci-fi%20key%20art%20of%20an%20astronaut%20floating%20before%20a%20distant%20planet%2C%20minimal%20dark%20neutral%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20muted%20sophisticated%20palette%2C%20professional%20poster%2C%20high%20detail&width=600&height=900&seq=poster-09&orientation=portrait',
    heroImage:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20panoramic%20key%20art%20of%20a%20vast%20starfield%20over%20a%20distant%20planet%20horizon%2C%20dramatic%20atmospheric%20lighting%2C%20minimal%20composition%20with%20copy%20space%2C%20elegant%20sci-fi%20editorial%20banner%2C%20high%20detail&width=1600&height=900&seq=hero-09&orientation=landscape',
    genres: ['科幻', '冒险', '剧情'],
    region: '美国',
    year: 2025,
    rating: 8.6,
    totalEpisodes: 10,
    updatedEpisodes: 6,
    status: '更新至第6集',
    updateDate: '2026-10-06',
    synopsis:
      '人类首次深空远征途中，飞船与地球失去联系。船员们必须在下一次跃迁窗口关闭前找到归家的坐标，而星辰大海的尽头，藏着一个改变命运的答案。',
    director: '郑成勋',
    cast: [
      { name: '顾清欢', role: '饰 指挥官 艾拉', avatar: actorAvatars[9] },
      { name: '陆时予', role: '饰 工程师 凯', avatar: actorAvatars[0] },
      { name: '许南烟', role: '饰 领航员 娜', avatar: actorAvatars[6] },
    ],
    tags: ['太空', '硬科幻', '冒险'],
    featured: true,
    views: '2.1亿',
  },
  {
    id: 'half-city',
    title: '半城烟雨',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20republican%20era%20drama%20key%20art%20of%20a%20woman%20in%20a%20vintage%20qipao%20under%20rainy%20old%20streets%2C%20minimal%20neutral%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20muted%20palette%2C%20professional%20poster%2C%20high%20detail&width=600&height=900&seq=poster-10&orientation=portrait',
    heroImage:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20panoramic%20key%20art%20of%20a%20rainy%20old%20city%20street%20with%20hanging%20lanterns%20at%20dusk%2C%20dramatic%20atmospheric%20lighting%2C%20minimal%20composition%20with%20copy%20space%2C%20elegant%20vintage%20banner%2C%20high%20detail&width=1600&height=900&seq=hero-10&orientation=landscape',
    genres: ['民国', '爱情', '年代'],
    region: '中国大陆',
    year: 2023,
    rating: 8.3,
    totalEpisodes: 45,
    updatedEpisodes: 45,
    status: '全45集',
    updateDate: '2026-08-30',
    synopsis:
      '烟雨朦胧的旧城里，一位留洋归来的医者与报馆女主笔因一篇报道相识。乱世之中，他们以笔与药为刃，守护着这座城市最后的体面与温柔。',
    director: '沈砚',
    cast: [
      { name: '林书曼', role: '饰 苏烟', avatar: actorAvatars[3] },
      { name: '郑北方', role: '饰 医生 沈砚之', avatar: actorAvatars[7] },
      { name: '唐棠', role: '饰 报馆主编', avatar: actorAvatars[5] },
    ],
    tags: ['民国', '情怀', '虐恋'],
    featured: false,
    views: '1.7亿',
  },
  {
    id: 'dawn-op',
    title: '破晓行动',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20action%20drama%20key%20art%20of%20an%20agent%20in%20a%20long%20coat%20amid%20a%20rainy%20night%20city%2C%20minimal%20dark%20neutral%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20muted%20palette%2C%20professional%20poster%2C%20high%20detail&width=600&height=900&seq=poster-11&orientation=portrait',
    heroImage:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20panoramic%20key%20art%20of%20a%20bridge%20over%20a%20river%20at%20dawn%20with%20cold%20mist%2C%20dramatic%20atmospheric%20lighting%2C%20minimal%20composition%20with%20copy%20space%2C%20elegant%20editorial%20banner%2C%20high%20detail&width=1600&height=900&seq=hero-11&orientation=landscape',
    genres: ['动作', '谍战', '悬疑'],
    region: '中国大陆',
    year: 2025,
    rating: 8.1,
    totalEpisodes: 32,
    updatedEpisodes: 20,
    status: '更新至第20集',
    updateDate: '2026-10-05',
    synopsis:
      '黎明前最黑暗的时刻，一支隐秘小队接到代号「破晓」的任务。他们必须在四十八小时内瓦解一张潜伏多年的暗网，用牺牲换取城市的新生。',
    director: '周叙',
    cast: [
      { name: '陆时予', role: '饰 队长 江寒', avatar: actorAvatars[8] },
      { name: '顾清欢', role: '饰 通讯兵 苏叶', avatar: actorAvatars[3] },
      { name: '秦淮', role: '饰 老前辈', avatar: actorAvatars[2] },
    ],
    tags: ['谍战', '团队', '高燃'],
    featured: false,
    views: '1.9亿',
  },
  {
    id: 'her-life',
    title: '她的人生',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20drama%20key%20art%20of%20a%20confident%20woman%20standing%20in%20a%20modern%20office%20lobby%2C%20minimal%20neutral%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20muted%20sophisticated%20palette%2C%20professional%20poster%2C%20high%20detail&width=600&height=900&seq=poster-12&orientation=portrait',
    heroImage:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20panoramic%20key%20art%20of%20a%20bright%20modern%20office%20at%20morning%20with%20large%20windows%2C%20dramatic%20atmospheric%20lighting%2C%20minimal%20composition%20with%20copy%20space%2C%20elegant%20editorial%20banner%2C%20high%20detail&width=1600&height=900&seq=hero-12&orientation=landscape',
    genres: ['都市', '女性', '剧情'],
    region: '中国大陆',
    year: 2024,
    rating: 8.5,
    totalEpisodes: 24,
    updatedEpisodes: 24,
    status: '全24集',
    updateDate: '2026-09-15',
    synopsis:
      '四十岁那年，她选择重新开始。离婚、失业、母亲的病痛接踵而至，她却用一场彻底的自我重建，回答了「女人究竟该怎样度过这一生」。',
    director: '叶知秋',
    cast: [
      { name: '唐棠', role: '饰 方知夏', avatar: actorAvatars[6] },
      { name: '林书曼', role: '饰 闺蜜 乐珊', avatar: actorAvatars[1] },
      { name: '何思远', role: '饰 前夫 周齐', avatar: actorAvatars[4] },
    ],
    tags: ['女性', '成长', '现实'],
    featured: false,
    views: '1.4亿',
  },
  {
    id: 'wind-youth',
    title: '追风少年',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20sports%20drama%20key%20art%20of%20a%20young%20runner%20sprinting%20on%20an%20open%20track%2C%20minimal%20neutral%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20muted%20palette%2C%20professional%20poster%2C%20high%20detail&width=600&height=900&seq=poster-13&orientation=portrait',
    heroImage:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20panoramic%20key%20art%20of%20a%20sunny%20athletics%20stadium%20track%20with%20long%20shadows%2C%20dramatic%20atmospheric%20lighting%2C%20minimal%20composition%20with%20copy%20space%2C%20elegant%20editorial%20banner%2C%20high%20detail&width=1600&height=900&seq=hero-13&orientation=landscape',
    genres: ['运动', '励志', '青春'],
    region: '中国大陆',
    year: 2025,
    rating: 7.8,
    totalEpisodes: 26,
    updatedEpisodes: 13,
    status: '更新至第13集',
    updateDate: '2026-10-04',
    synopsis:
      '被伤病击垮的天才短跑少年重回赛道，在一群「不完美」的队友陪伴下，他重新学会奔跑的意义——不是为了赢，而是为了不错过风。',
    director: '周叙',
    cast: [
      { name: '何思远', role: '饰 陈野', avatar: actorAvatars[4] },
      { name: '苏晚晴', role: '饰 队医 林薇', avatar: actorAvatars[7] },
      { name: '秦淮', role: '饰 教练', avatar: actorAvatars[2] },
    ],
    tags: ['热血', '励志', '青春'],
    featured: false,
    views: '9200万',
  },
  {
    id: 'old-alley',
    title: '旧巷深处',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20mystery%20drama%20key%20art%20of%20a%20figure%20walking%20down%20a%20narrow%20old%20alley%20at%20dusk%2C%20minimal%20neutral%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20muted%20palette%2C%20professional%20poster%2C%20high%20detail&width=600&height=900&seq=poster-14&orientation=portrait',
    heroImage:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20panoramic%20key%20art%20of%20an%20old%20alley%20with%20stone%20walls%20at%20blue%20hour%2C%20dramatic%20atmospheric%20lighting%2C%20minimal%20composition%20with%20copy%20space%2C%20elegant%20editorial%20banner%2C%20high%20detail&width=1600&height=900&seq=hero-14&orientation=landscape',
    genres: ['悬疑', '家庭', '剧情'],
    region: '中国大陆',
    year: 2024,
    rating: 8.4,
    totalEpisodes: 18,
    updatedEpisodes: 18,
    status: '全18集',
    updateDate: '2026-09-10',
    synopsis:
      '老巷拆迁在即，一件被埋藏多年的往事随着一封信重见天日。归乡的女儿必须在推倒老屋之前，找回那段被全家刻意遗忘的真相。',
    director: '沈砚',
    cast: [
      { name: '林书曼', role: '饰 文清', avatar: actorAvatars[1] },
      { name: '秦淮', role: '饰 父亲', avatar: actorAvatars[2] },
      { name: '许南烟', role: '饰 邻居 赵姨', avatar: actorAvatars[6] },
    ],
    tags: ['悬疑', '家庭', '年代'],
    featured: false,
    views: '1.0亿',
  },
  {
    id: 'cloud-melody',
    title: '云上牧歌',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20drama%20key%20art%20of%20a%20shepherd%20on%20a%20green%20highland%20meadow%20under%20soft%20clouds%2C%20minimal%20neutral%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20muted%20palette%2C%20professional%20poster%2C%20high%20detail&width=600&height=900&seq=poster-15&orientation=portrait',
    heroImage:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20panoramic%20key%20art%20of%20rolling%20green%20highlands%20under%20dramatic%20clouds%2C%20dramatic%20atmospheric%20lighting%2C%20minimal%20composition%20with%20copy%20space%2C%20elegant%20editorial%20banner%2C%20high%20detail&width=1600&height=900&seq=hero-15&orientation=landscape',
    genres: ['乡村', '温情', '剧情'],
    region: '中国大陆',
    year: 2023,
    rating: 8.6,
    totalEpisodes: 30,
    updatedEpisodes: 30,
    status: '全30集',
    updateDate: '2026-08-28',
    synopsis:
      '放弃城市工作的姑娘回到高原牧场，与固执的老牧人一起守护即将消失的牧道。悠长的牧歌里，是一代人关于土地与传承的深情告白。',
    director: '叶知秋',
    cast: [
      { name: '苏晚晴', role: '饰 卓玛', avatar: actorAvatars[7] },
      { name: '秦淮', role: '饰 老牧人', avatar: actorAvatars[2] },
      { name: '何思远', role: '饰 兽医 小陆', avatar: actorAvatars[4] },
    ],
    tags: ['治愈', '乡村', '慢生活'],
    featured: false,
    views: '1.1亿',
  },
  {
    id: 'backlight',
    title: '逆光而行',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20drama%20key%20art%20of%20a%20businesswoman%20before%20a%20glass%20office%20skyscraper%20at%20dawn%2C%20minimal%20neutral%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20muted%20palette%2C%20professional%20poster%2C%20high%20detail&width=600&height=900&seq=poster-16&orientation=portrait',
    heroImage:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20panoramic%20key%20art%20of%20a%20modern%20glass%20office%20skyline%20at%20dawn%20with%20warm%20light%2C%20dramatic%20atmospheric%20lighting%2C%20minimal%20composition%20with%20copy%20space%2C%20elegant%20editorial%20banner%2C%20high%20detail&width=1600&height=900&seq=hero-16&orientation=landscape',
    genres: ['职场', '都市', '剧情'],
    region: '中国大陆',
    year: 2025,
    rating: 8.0,
    totalEpisodes: 28,
    updatedEpisodes: 16,
    status: '更新至第16集',
    updateDate: '2026-10-08',
    synopsis:
      '初入投行的实习生在一场并购案中发现了被掩盖的真相。面对利益与良知的拉扯，她选择逆着众人期待的光，走一条更难却更正确的路。',
    director: '周叙',
    cast: [
      { name: '林书曼', role: '饰 实习生 沈知', avatar: actorAvatars[9] },
      { name: '郑北方', role: '饰 总监 陆铭', avatar: actorAvatars[7] },
      { name: '唐棠', role: '饰 合伙人 江总', avatar: actorAvatars[5] },
    ],
    tags: ['职场', '成长', '商战'],
    featured: true,
    views: '1.6亿',
  },
  {
    id: 'sky-pavilion',
    title: '天机阁',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20costume%20mystery%20key%20art%20of%20an%20ancient%20scholar%20in%20a%20dim%20lantern%20lit%20library%2C%20minimal%20neutral%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20muted%20palette%2C%20professional%20poster%2C%20high%20detail&width=600&height=900&seq=poster-17&orientation=portrait',
    heroImage:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20panoramic%20key%20art%20of%20an%20ancient%20lantern%20lit%20pavilion%20at%20night%20in%20mist%2C%20dramatic%20atmospheric%20lighting%2C%20minimal%20composition%20with%20copy%20space%2C%20elegant%20oriental%20banner%2C%20high%20detail&width=1600&height=900&seq=hero-17&orientation=landscape',
    genres: ['古装', '悬疑', '剧情'],
    region: '中国大陆',
    year: 2025,
    rating: 8.7,
    totalEpisodes: 36,
    updatedEpisodes: 24,
    status: '更新至第24集',
    updateDate: '2026-10-09',
    synopsis:
      '天机阁掌管天下机密，却算不出自己的生死。年轻的阁主在追查师父之死时，发现每一条线索都指向一段被刻意抹去的王朝秘史。',
    director: '沈砚',
    cast: [
      { name: '宋清辞', role: '饰 阁主 谢云舟', avatar: actorAvatars[0] },
      { name: '顾清欢', role: '饰 女官 苏绾', avatar: actorAvatars[3] },
      { name: '许南烟', role: '饰 太傅', avatar: actorAvatars[6] },
    ],
    tags: ['古装', '悬疑', '权谋'],
    featured: false,
    views: '2.4亿',
  },
  {
    id: 'goodbye-youth',
    title: '再见青春',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20youth%20drama%20key%20art%20of%20two%20students%20on%20a%20seaside%20promenade%20at%20golden%20hour%2C%20minimal%20neutral%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20muted%20palette%2C%20professional%20poster%2C%20high%20detail&width=600&height=900&seq=poster-18&orientation=portrait',
    heroImage:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20panoramic%20key%20art%20of%20a%20seaside%20promenade%20at%20sunset%20with%20soft%20golden%20light%2C%20dramatic%20atmospheric%20lighting%2C%20minimal%20composition%20with%20copy%20space%2C%20elegant%20editorial%20banner%2C%20high%20detail&width=1600&height=900&seq=hero-18&orientation=landscape',
    genres: ['青春', '爱情', '校园'],
    region: '韩国',
    year: 2024,
    rating: 7.7,
    totalEpisodes: 16,
    updatedEpisodes: 16,
    status: '全16集',
    updateDate: '2026-09-08',
    synopsis:
      '毕业十年后，五個老朋友重新回到那座海边小城。他们翻出当年的录音带，在笑声与眼泪中，与那段再也回不去的青春好好告别。',
    director: '郑成勋',
    cast: [
      { name: '苏晚晴', role: '饰 智秀', avatar: actorAvatars[7] },
      { name: '何思远', role: '饰 贤宇', avatar: actorAvatars[4] },
      { name: '林书曼', role: '饰 敏静', avatar: actorAvatars[1] },
    ],
    tags: ['青春', '怀旧', '治愈'],
    featured: false,
    views: '7400万',
  },
  {
    id: 'nameless',
    title: '无名之辈',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20drama%20key%20art%20of%20an%20ordinary%20man%20standing%20in%20a%20small%20town%20street%20at%20dusk%2C%20minimal%20neutral%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20muted%20palette%2C%20professional%20poster%2C%20high%20detail&width=600&height=900&seq=poster-19&orientation=portrait',
    heroImage:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20panoramic%20key%20art%20of%20a%20small%20town%20main%20street%20at%20dusk%20with%20warm%20lamps%2C%20dramatic%20atmospheric%20lighting%2C%20minimal%20composition%20with%20copy%20space%2C%20elegant%20editorial%20banner%2C%20high%20detail&width=1600&height=900&seq=hero-19&orientation=landscape',
    genres: ['剧情', '黑色幽默', '都市'],
    region: '中国大陆',
    year: 2024,
    rating: 8.5,
    totalEpisodes: 20,
    updatedEpisodes: 20,
    status: '全20集',
    updateDate: '2026-09-05',
    synopsis:
      '一桩乌龙抢劫案，把几个毫不相干的小人物卷到一起。他们笨拙、狼狈，却在命运的玩笑里，意外活成了彼此生命中的英雄。',
    director: '周叙',
    cast: [
      { name: '郑北方', role: '饰 老陈', avatar: actorAvatars[2] },
      { name: '何思远', role: '饰 小北', avatar: actorAvatars[4] },
      { name: '苏晚晴', role: '饰 阿珍', avatar: actorAvatars[7] },
    ],
    tags: ['市井', '幽默', '群像'],
    featured: false,
    views: '1.3亿',
  },
  {
    id: 'winter-spring',
    title: '冬去春来',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20family%20drama%20key%20art%20of%20a%20village%20family%20in%20snowy%20countryside%2C%20minimal%20neutral%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20muted%20palette%2C%20professional%20poster%2C%20high%20detail&width=600&height=900&seq=poster-20&orientation=portrait',
    heroImage:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20panoramic%20key%20art%20of%20a%20snowy%20countryside%20village%20at%20dusk%20with%20warm%20chimney%20smoke%2C%20dramatic%20atmospheric%20lighting%2C%20minimal%20composition%20with%20copy%20space%2C%20elegant%20editorial%20banner%2C%20high%20detail&width=1600&height=900&seq=hero-20&orientation=landscape',
    genres: ['家庭', '年代', '剧情'],
    region: '中国大陆',
    year: 2023,
    rating: 8.9,
    totalEpisodes: 38,
    updatedEpisodes: 38,
    status: '全38集',
    updateDate: '2026-08-25',
    synopsis:
      '从大雪封门的那年冬天起，一个北方家庭三代人的命运随着时代缓缓流转。冬去春来，他们失去过、等待过，也终于在同一张饭桌前重新团圆。',
    director: '叶知秋',
    cast: [
      { name: '唐棠', role: '饰 母亲 桂兰', avatar: actorAvatars[5] },
      { name: '郑北方', role: '饰 父亲 王建国', avatar: actorAvatars[2] },
      { name: '何思远', role: '饰 长子 王春生', avatar: actorAvatars[4] },
    ],
    tags: ['年代', '家庭', '催泪'],
    featured: false,
    views: '2.0亿',
  },
];

export const genreOptions: string[] = [
  '剧情',
  '爱情',
  '家庭',
  '悬疑',
  '都市',
  '古装',
  '犯罪',
  '青春',
  '科幻',
  '动作',
  '民国',
  '女性',
  '运动',
  '乡村',
  '职场',
  '年代',
  '治愈',
  '冒险',
  '校园',
  '黑色幽默',
];

export const regionOptions: string[] = [
  '中国大陆',
  '中国香港',
  '中国台湾',
  '韩国',
  '日本',
  '美国',
  '英国',
];

export const yearOptions: string[] = ['2025', '2024', '2023'];